<template>
  <div class="shopping-cart" id="shop_cart">
    <back-header class="head-top" title="购物车">
      <span class="management" @click="isEdit = !isEdit">管理</span>
    </back-header>
    <scroll ref="scroll" :is-finished="finished" :pull-down-refresh="{threshold: 70, stop: 56}" @pullingDown="pullingDown" @scrollToEnd="scrollToEnd" clickable>
      <div class="order" v-for="(item, index) in list" :key="item.id">
        <order-store :store="item.store" @toggleStore="toggleStore" show-checkbox :index="index"/>
        <div class="goods" v-for="(goods, idx) in item.goods" :key="goods.delId">
          <OrderItem @toggleGoods="toggleGoods" :par-index="index" :own-index="idx" :goods="goods" show-checkbox/>
          <div class="price">
            <p>{{ goods.price }}</p>
            <van-stepper @change="changeNum(goods)" v-model="goods.count" button-size="0.66rem" input-width="0.66rem" disable-input />
          </div>
        </div>
      </div>
    </scroll>
    <div class="buy">
      <van-checkbox @change="toggleAll" v-model="checkedAll" icon-size="0.36rem" checked-color="#E1244E" />
      <p class="all" @click="checkedAll=!checkedAll">全选</p>
      <i></i>
      <p class="total">合计</p>
      <p class="total-price">¥{{ totalPrice }}</p>
      <div style="flex: 1"></div>
      <button @click="buy">{{ isEdit ? '删除' : '结算' }}</button>
    </div>
  </div>
</template>

<script>
import BackHeader from '../../components/back-header/back-header'
import Scroll from '../../components/scroll/scroll'
import OrderStore from '../../components/order-store/order-store'
import OrderItem from '../../components/order-item/order-item'
import { post } from '../../common/js/http'
import cloneDeep from '../../common/js/clone-deep'

const PAGE_SIZE = 10

export default {
  name: 'shopping-cart',
  components: {
    BackHeader,
    Scroll,
    OrderStore,
    OrderItem
  },
  data() {
    return {
      list: [],
      checkedAll: false,
      totalPrice: '0.00',
      childChange: false,
      params: [],
      allChange: false,
      page: 1,
      isEdit: false,
      ids: '',
      finished: true
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    genTotal() {
      if (this.genTimer) clearTimeout(this.genTimer)
      this.genTimer = setTimeout(() => {
        let total = 0
        let ids = ''
        const copy = JSON.parse(JSON.stringify(this.list))
        for (let i = 0; i < copy.length; i++) {
          const item = copy[i]
          for (let j = 0; j < item.goods.length; j++) {
            if (!item.goods[j].checked) {
              item.goods.splice(j, 1)
              j--
            } else {
              ids += `,${item.goods[j].delId}`
              total += item.goods[j].price * item.goods[j].count
            }
          }
          if (!item.goods.length) {
            copy.splice(i, 1)
            i--
          }
        }
        this.totalPrice = total.toFixed(2)
        this.ids = ids
        this.params = copy
      }, 100)
    },
    changeNum(goods) {
      this.genTotal()
      this.changeGoodsCount(goods)
    },
    toggleStore({ index }) {
      if (this.childChange || this.allChange) return
      const item = JSON.parse(JSON.stringify(this.list[index]))
      if (item.store.checked) {
        item.goods.forEach(goods => {
          goods.checked = true
        })
      } else {
        item.goods.forEach(goods => {
          goods.checked = false
        })
      }
      this.$set(this.list, index, item)
      this.checkAll()
      this.genTotal()
    },
    toggleGoods({ parIndex }) {
      if (this.allChange) return
      const item = JSON.parse(JSON.stringify(this.list[parIndex]))
      item.store.checked = !item.goods.some(item => !item.checked)
      this.$set(this.list, parIndex, item)
      this.childChange = true
      this.$nextTick(() => {
        this.childChange = false
      })
      this.checkAll()
      this.genTotal()
    },
    changeGoodsCount(goods) {
      clearTimeout(this.changeCountTimer)
      this.changeCountTimer = setTimeout(() => {
        post('/shop/cart/editCartGoodsCount', {
          cartgoodsid: goods.delId,
          count: goods.count
        })
      }, 200)
    },
    toggleAll() {
      if (this.childChange) return
      this.allChange = true
      const copy = JSON.parse(JSON.stringify(this.list))
      copy.forEach(item => {
        item.store.checked = this.checkedAll
        item.goods.forEach(goods => {
          goods.checked = this.checkedAll
        })
      })
      this.list = copy
      this.genTotal()
      this.$nextTick(() => {
        this.allChange = false
      })
    },
    checkAll() {
      this.checkedAll = !this.list.some(item => !item.store.checked)
    },
    buy() {
      if (!this.params.length) {
        this.$toast.fail('请选择商品')
        return
      }
      if (!this.isEdit) {
        this.$router.push({
          params: {
            order: this.params
          },
          name: 'place-order'
        })
      } else {
        this.delGoods()
      }
    },
    getList(fullLoading = true) {
      let loading = null
      if (this.page === 1 && fullLoading) {
        loading = this.$skeLoading('#shop_cart')
      }
      post('/shop/cart/getCartGoodsList', {
        page: this.page,
        size: PAGE_SIZE
      })
        .then(({ data: { data } }) => {
          this.finished = data.length < PAGE_SIZE
          const list = data.map(item => {
            return {
              id: item.id,
              shopid: item.shop.id,
              store: {
                ...item.shop.user,
                checked: false
              },
              remark: '',
              goods: item.cartgoods.map(goods => {
                return {
                  id: goods.goodsid,
                  count: goods.count,
                  delId: goods.id,
                  cover: goods.inventory.color.img_url || goods.goods.thumb_urls.split(',')[0],
                  title: goods.goods.title,
                  size: goods.inventory.color.color + (goods.inventory.size ? goods.inventory.size.size : ''),
                  price: goods.inventory.price,
                  checked: false,
                  inventoryid: goods.inventory.id
                }
              })
            }
          })
          this.list = this.page === 1 ? list : this.list.concat(list)
          this.loading = false
          this.$refs.scroll.closeRefresh()
          loading && loading.close()
        })
        .catch(() => {
          this.loading = false
          loading && loading.close()
        })
    },
    scrollToEnd() {
      if (this.loading) return
      this.loading = true
      this.page++
      this.getList()
    },
    pullingDown() {
      this.page = 1
      this.getList(false)
    },
    delGoods() {
      const loading = this.$toast.loading()
      post('/shop/cart/delCartGoods', {
        cartgoodsids: this.ids
      })
        .then(() => {
          const copy = cloneDeep(this.list)
          for (let i = 0; i < copy.length; i++) {
            if (copy[i].store.checked) {
              copy.splice(i, 1)
              i--
            } else {
              for (let j = 0; j < copy[i].goods.length; j++) {
                if (copy[i].goods[j].checked) {
                  copy[i].goods.splice(j, 1)
                  j--
                }
              }
            }
          }
          this.list = copy
          loading.close()
          this.genTotal()
        })
        .catch(() => {
          loading.close()
        })
    }
  }
}
</script>

<style scoped lang="stylus">
.shopping-cart
  width 100%
  padding-top 86px
  padding-bottom 106px
  box-sizing border-box
  background #FBFAFA
  .management
    font-size 30px
    color #000000
  .order
    padding 38px 30px 0 30px
    margin-top 24px
    background #fff
    .goods
      padding-bottom 40px
    .price
      display flex
      padding-left 253px
      align-items center
      justify-content space-between
      &>p
        font-weight bold
        font-size 30px
        color #E1244E
      ::v-deep
        .van-stepper
          .van-stepper__input
            background-color transparent
            font-size 26px !important
            color #6C6C6C
  .buy
    position fixed
    height 106px
    bottom 0
    left 0
    width 100%
    background #fff
    display flex
    align-items center
    box-sizing border-box
    padding 0 30px
    .all
      padding-left 26px
      font-size 24px
      color #666666
    &>i
      margin 0 19px
      width 1px
      height 23px
      background #CFCFCF
    .total
      margin-right 18px
      font-size 24px
      color #000000
    .total-price
      font-size 30px
      color #E1244E
    &>button
      width 217px
      height 79px
      border-radius 40px
      background linear-gradient(-90deg,rgba(254,37,89,1),rgba(241,43,131,1))
      border none
      outline none
      font-size 30px
      color #FFFFFF
</style>
